import { render } from "./ContactChannelIcon.vue?vue&type=template&id=539183d6&ts=true"
import script from "./ContactChannelIcon.vue?vue&type=script&lang=ts"
export * from "./ContactChannelIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__